import { Head, router } from "@inertiajs/react";
import { useState } from "react";

import Layout from "/AdminLayout";
import ProjectForm from "/components/Admin/ProjectForm";

import { useToast } from "/utils/toast-context.jsx";
import createProjectStore from "/hooks/stores/projectStore";

const EditProject = ({
  project,
  errors,
}) => {
  // Created once per mount: re-running this on every render would rebuild the
  // store from the server props and discard the user's unsaved edits (which is
  // what happens when a failed submit re-renders the page with `errors`).
  const [useProjectStore] = useState(() => createProjectStore(project));
  const { successToast } = useToast();

  const handleSubmit = (state, preview = false) => {
    const data = useProjectStore.getState().getAllData();
    data.state = state;
    if (preview)
      data.preview = preview;
    router.put(
      `/admin/projects/${project.id}`,
      data,
      {
        forceFormData: true,
        preserveScroll: true,
        onSuccess: () => successToast("Сохранено"),
      }
    );
  };

  return (
    <>
      <Head>
        <title>Редактирование проекта</title>
      </Head>
      <ProjectForm
        onSubmit={handleSubmit}
        useStore={useProjectStore}
        errors={errors}
      />
    </>
  );
}

EditProject.layout = (page) => <Layout children={page} />;

export default EditProject;
